import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import AuthProvider from '../../providers/auth.provider';
import CheckCMSNewVersionLayer from '../../components/layout/CheckCMSNewVersionLayer';
import { config } from '../../config';

const liffId = config.liff_id.paymentPremium;

const PaymentPremium = loadable(() => import('./PaymentPremium'), { fallback: null });

const PaymentPremiumForm = loadable(() => import('./PaymentPremiumForm'), { fallback: null });

const PaymentPremiumComplete = loadable(() => import('./PaymentPremiumComplete'), { fallback: null });

const NotFound = loadable(() => import('../NotFound'), { fallback: null });

export default function PaymentPremiumRoute() {
	return (
		<Routes>
			<Route path="/" element={
				<AuthProvider liffId={liffId}>
					<CheckCMSNewVersionLayer>
						<PaymentPremium />
					</CheckCMSNewVersionLayer>
				</AuthProvider>
			} />
			<Route path="form/:policyCertNo" element={<PaymentPremiumForm />} />
			<Route path="complete" element={
				<AuthProvider liffId={liffId}>
					<PaymentPremiumComplete />
				</AuthProvider>
			} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
}
